// @flow
import React, { Component } from 'react';
import classNames from 'classnames';
import Crown from './Crown';
import DiscoveryTags from '../DiscoveryTags/DiscoveryTags';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import Login from './Login/Login';
import MobileNavigation from './Navigation/MobileNavigation';
import Navigation from './Navigation/Navigation';
import SearchInput from '../../components/SearchInput/SearchInput';
import SignupAction from '../../components/Modals/SignUp/SignupAction';
import styles from './Header.module.scss';

type Props = {|
    baseUrl: string,
    isClientHydrated: boolean,
    logo: string,
    logOutBidder: Function,
    mobile: string,
    openLoginModal: Function,
    openSignUpModal: Function,
    pathname: string,
    queryParams: any,
    trackPastAuctionResultsClick: Function,
    trackPriceResultsClick: Function,
    userDataLoading: boolean,
    userFirstName: string,
    userLoggedIn: boolean,
    whiteLabel: boolean,
    windowWidth: number,
|};

export default class Header extends Component<Props> {
    shouldComponentUpdate = (nextProps: Props) => !isEqual(this.props, nextProps);

    render() {
        const {
            baseUrl,
            isClientHydrated,
            logo,
            logOutBidder,
            mobile,
            openLoginModal,
            openSignUpModal,
            pathname,
            queryParams,
            trackPastAuctionResultsClick,
            trackPriceResultsClick,
            userDataLoading,
            userFirstName,
            userLoggedIn,
            whiteLabel,
            windowWidth,
        } = this.props;

        const headerLogo = logo;
        const searchBarDesktop = 'search-bar-desktop';
        const searchBarMobile = 'search-bar-mobile';

        return (
            <div className={styles.header}>
                {windowWidth > 767 && <Crown pathname={pathname} whiteLabel={whiteLabel} />}
                {isClientHydrated && <SignupAction isLoggedIn={userLoggedIn} />}
                <div className={`${styles.wrapper}${whiteLabel ? ` ${styles['white-label']}` : ''}`}>
                    <div className={classNames(styles['search-bar'], { [styles.loggedIn]: userLoggedIn })}>
                        <div className={styles['image-container']}>
                            {!whiteLabel && windowWidth <= 767 && (
                                <MobileNavigation
                                    baseUrl={baseUrl}
                                    header={
                                        headerLogo && (
                                            <img alt="logo" className={styles.mobileNavLogo} src={headerLogo} />
                                        )
                                    }
                                    trackPriceResultsClick={trackPriceResultsClick}
                                />
                            )}
                            <Link className={styles['header-logo-link']} route to="/">
                                {headerLogo && <img alt="logo" className={styles['header-logo']} src={headerLogo} />}
                            </Link>
                        </div>
                        <div className={styles['search-field-container']}>
                            {/* special element for Jasper52 */}
                            <div className={styles['exceptional-items']} id="exceptional-items">
                                <FormattedMessage id="header.j52" />
                            </div>
                            {windowWidth > 767 && (
                                <SearchInput
                                    id="desktop-search"
                                    name={searchBarDesktop}
                                    pathname={pathname}
                                    queryParams={queryParams}
                                />
                            )}
                        </div>
                        <div className={styles['controls-container']}>
                            <Login
                                baseUrl={baseUrl}
                                logOutBidder={logOutBidder}
                                openLoginModal={openLoginModal}
                                openSignUpModal={openSignUpModal}
                                parent={this}
                                pathname={pathname}
                                userDataLoading={userDataLoading}
                                userFirstName={userFirstName}
                                userLoggedIn={userLoggedIn}
                                whiteLabel={whiteLabel}
                                windowWidth={windowWidth}
                            />
                        </div>
                    </div>
                    {windowWidth <= 767 && (
                        <div className={classNames(styles['mobile-search'], styles.show)}>
                            <SearchInput
                                id="mobile-search"
                                name={searchBarMobile}
                                pathname={pathname}
                                queryParams={queryParams}
                                reverseButton
                            />
                        </div>
                    )}
                </div>
                {!whiteLabel && windowWidth > 767 && (
                    <Navigation
                        mobile={mobile}
                        parent={this}
                        trackPastAuctionResultsClick={trackPastAuctionResultsClick}
                    />
                )}
                {!whiteLabel && windowWidth <= 767 && (
                    <DiscoveryTags className={styles.tags} key="discoveryTags" width={windowWidth} />
                )}
            </div>
        );
    }
}
